import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';
import { ConnectionService } from '../../../../services/connection-service';
import { RequestQueryPayload, Table } from '@cureskin/api-client';
@Injectable()
export class HeroIngredientResolve implements Resolve<any> {
  constructor(private conn: ConnectionService, private router: Router) {}

  resolve(route: ActivatedRouteSnapshot) {
    const id = route.params.id;
    const payload: RequestQueryPayload<Table.HeroIngredient> = { where: { objectId: id }, include: ['nameLanguageString', 'name'] }
    return this.conn.findHeroIngredient(payload)
    .then((heroIngredientObj: any) => {
      if (heroIngredientObj) {
        return Promise.resolve(heroIngredientObj);
      }
      this.router.navigate(['/products/catalogs/hero-ingredient']);
      return false;
    })
  }
}
